import { render, staticRenderFns } from "./QueueRecordCount.vue?vue&type=template&id=4b161f38&"
import script from "./QueueRecordCount.vue?vue&type=script&lang=js&"
export * from "./QueueRecordCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports